import React, { Component } from 'react';

import { ProgressBar, Table } from 'react-bootstrap';
import { EXPANSION_NAMES, EXPANSIONS, getAllCardsForPlayer, getSingleCardData } from '../../Common/CardUtilities';
import { getAmenityTextureUrl, getBedTextureUrl, getCardTextureUrl, getFactionTextureUrl } from '../../Common/TextureTools';
import './deck-bar.css';
import GamePlayerPools2d from '../../Controls/Pools';
import FireIcon from '../../Common/FireIcon';
import CheckmarkIcon from '../../Common/CheckmarkIcon';


export class Expansions extends Component {
    render() {
        return <>
            {this.props.gameData.options.config.expansions.map((expansionId) => {
                let expansionCards = EXPANSIONS[expansionId];
                let expansionName = EXPANSION_NAMES[expansionId];
                return <tr key={`ex-${expansionId}`}>
                    <td>{expansionName}</td>
                    {expansionCards.map((cardId, key) => {
                        let card = getSingleCardData(
                            cardId,
                            this.props.gameData, this.props.gamePlayerData);
                        if (card.found) {
                            return <td key={`ex-${expansionId}-${key}`}>{this.props.cardFunction(card)}</td>;
                        } else {
                            return <td key={`ex-${expansionId}-${key}`}/>;
                        }
                    })}
                </tr>;
            })
            }
        </>;
    }
}

export class DeckGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };

        this.amenities = [
            getAmenityTextureUrl(1),
            getAmenityTextureUrl(2),
            getAmenityTextureUrl(3),
            getAmenityTextureUrl(4),
            getAmenityTextureUrl(5),
            getAmenityTextureUrl(6),
        ];

        this.factions = [
            getFactionTextureUrl(1),
            getFactionTextureUrl(2),
            getFactionTextureUrl(3),
            getFactionTextureUrl(4),
            getFactionTextureUrl(5),
            getFactionTextureUrl(6),
        ];
        this.beds = [
            getBedTextureUrl(1),
            getBedTextureUrl(2),
            getBedTextureUrl(3),
            getBedTextureUrl(4),
            getBedTextureUrl(5),
            getBedTextureUrl(6),
        ];
    }

    componentDidMount() {
        window.addEventListener('show-deck-grid-event', this.showGrid);
        window.addEventListener('hide-deck-grid-event', this.showGrid);
        window.addEventListener('toggle-deck-grid-event', this.toggleGrid);
    }

    componentWillUnmount() {
        window.removeEventListener('show-deck-grid-event', this.showGrid);
        window.removeEventListener('hide-deck-grid-event', this.showGrid);
        window.removeEventListener('toggle-deck-grid-event', this.toggleGrid);
    }

    showGrid = () => {
        this.setState({ show: true });
    };

    hideGrid = () => {
        this.setState({ show: false });
    };

    toggleGrid = () => {
        this.setState({ show: !this.state.show });
    };
    card = (card) => {
        let cardId = card.id;
        let src;
        if (cardId) {
            src = getCardTextureUrl(cardId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }
        let matchingLodging = card.matchingLodging;
        let matchingAmenity = card.matchingAmenity;
        let matchingBed = card.matchingBed;
        let willBurn = card.willBurn;
        let isGuest = card.guestDeck;
        let isDiscarded = card.discardDeck;
        let isBurned = card.isBurned;
        let inTradelane = card.tradelaneIndex !== null;
        // let highlight = this.state.highlightedOrbits.includes(orbitIndex);
        // let availableDocks = orbit.available_docks;
        // let unoccupiedDocsWBed = orbit.unoccupied_docs_with_beds;
        // let discard = this.state.discardOrbit === orbitIndex;

        let imageClass = 'deck-grid-card-image';
        if (isBurned) {
            imageClass += ' deck-grid-card-burned';
        }

        return <div className={'deck-grid-card'} key={cardId} >
            <div className={'deck-grid-card-cell-container'}>
                <div className={'deck-grid-card-anchor'}>
                    <div className={'deck-grid-card-container'}>
                        {matchingLodging && <CheckmarkIcon className={'deck-grid-card-matching-left'}/>}
                        {matchingAmenity && <CheckmarkIcon className={'deck-grid-card-matching-right'}/>}
                        {matchingBed && <img className={'deck-grid-card-matching-bed'}
                                             src={this.beds[card.faction - 1]}
                                             alt={'bed'}
                        />}
                        {isGuest && <div className={'deck-grid-guest-deck'}/>}
                        {isDiscarded && <div className={'deck-grid-discard-deck'}/>}
                        {inTradelane && <div className={'deck-grid-tradelane-card'}/>}
                        {willBurn && <FireIcon className={'deck-grid-card-will-burn'}/>}
                    </div>
                </div>
                <img className={imageClass}
                     src={src}
                     alt={'card'}
                />
            </div>
        </div>;
    };



    cardGrid = () => {
        let deck = getAllCardsForPlayer(
            this.props.gameData, this.props.gamePlayerData);
        const rowId = [ 0, 1, 2, 3, 4, 5 ];
        const colId = [ 0, 1, 2, 3, 4, 5 ];
        let grid = [];
        rowId.forEach((rowId) => {
            let row = [];
            let rowIndex = <td key={`row-index-${rowId}`}>{
                <img src={this.amenities[rowId]}
                     alt={`rowId-${rowId}`}
                     className={'deck-grid-index-room'}
                />
            }</td>;
            row.push(rowIndex);
            colId.forEach((colId) => {
                let cardIndex = colId * 6 + rowId;
                let cardId = cardIndex + 1;
                let card = deck[cardId];
                let element;
                if (card && card.found) {
                    element = <td key={`card-${cardId}`}>
                        {this.card(card)}
                    </td>
                } else {
                    element = <td key={`card-${cardId}`} />
                }
                row.push(element);
            });
            let rowElement = <tr key={`row-${rowId}`}>
                {row}
            </tr>;
            grid.push(rowElement);
        });
        let gridElement = <Table className={'deck-grid-table'}>
            <thead>
            </thead>
            <tbody key={'no-key'}>
            <tr>
                <td/>
                <td>
                    <img src={this.factions[0]}
                         alt={`faction-${0}`}
                         className={'deck-grid-index-room'}
                         title={'deep'}
                    />
                </td>
                <td>

                    <img src={this.factions[1]}
                         alt={`faction-${1}`}
                         className={'deck-grid-index-room'}
                         title={'stem'}
                    />
                </td>
                <td>

                    <img src={this.factions[2]}
                         alt={`faction-${2}`}
                         className={'deck-grid-index-room'}
                         title={'hex'}
                    />
                </td>
                <td>

                    <img src={this.factions[3]}
                         alt={`faction-${3}`}
                         className={'deck-grid-index-room'}
                         title={'dread'}
                    />
                </td>
                <td>

                    <img src={this.factions[4]}
                         alt={`faction-${4}`}
                         className={'deck-grid-index-room'}
                         title={'honored'}
                    />
                </td>
                <td>

                    <img src={this.factions[5]}
                         alt={`faction-${5}`}
                         className={'deck-grid-index-room'}
                         title={'seed'}
                    />
                </td>
            </tr>
            {grid}
            <Expansions {...this.props} cardFunction={this.card}/>
            </tbody>
        </Table>;
        return gridElement;
    };


    render() {
        if (!this.state.show) return <></>;
        return <div className={'deck-grid'}
                    onClick={this.hideGrid}>
            <div className={'deck-grid-body'}>
                <div className={'deck-grid-top-row'}>
                    <div style={{ background: 'var(--honored)' }} className={'deck-grid-top-item'}>Tradelane</div>
                    <div style={{ background: 'var(--seed)' }} className={'deck-grid-top-item'}>Draw</div>
                    <div style={{ background: 'grey' }} className={'deck-grid-top-item'}>Discard</div>
                    <div style={{ background: 'var(--dread)' }} className={'deck-grid-top-item'}>Will Burn</div>
                </div>
                {this.cardGrid()}
            </div>
            <GamePlayerPools2d {...this.props}/>
            <hr/>
        </div>;
    }
}


export class DeckBar extends Component {

    showGrid = () => {
        window.dispatchEvent(new Event('show-deck-grid-event'));
    };

    hideGrid = () => {
        window.dispatchEvent(new Event('hide-deck-grid-event'));
    };

    toggleGrid = () => {
        window.dispatchEvent(new Event('toggle-deck-grid-event'));
    };


    render() {
        let gameData = this.props.gameData;
        let gamePlayerData = this.props.gamePlayerData;

        if (!gamePlayerData) {
            return <></>;
        }

        let guestDeckCount = gameData.guest_deck.length;
        let discardDeckCount = gameData.discard_deck.length;
        let total = guestDeckCount + discardDeckCount;

        return (<>
            <div className={'deck-bar'}
                 data-ftue-target={'deck-bar'}
                 // onMouseEnter={this.showGrid}
                 onClick={this.toggleGrid}
            >
                <ProgressBar className={'deck-progress-bar'}>
                    <ProgressBar variant={'honored'}
                                 min={0}
                                 max={total}
                                 now={guestDeckCount}
                                 key={1}
                                 label={guestDeckCount}
                    />
                    <ProgressBar variant={'dread'}
                                 min={0}
                                 max={total}
                                 now={discardDeckCount}
                                 key={2}
                                 label={discardDeckCount}
                    />
                </ProgressBar>
                {/* {this.state.show && <> */}
                {/*     <DeckGrid {...this.props} /> */}
                {/* </> */}
                {/* } */}
            </div>
        </>);
    }
}
